import {Component, Input} from "@angular/core";
import {GefAuditDto} from "../../../../core/dtos/gef/gef-audit-dto";
import {GestionGefService} from "../../../../core/services/gef/gestion-gef.service";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {HAS_GEF} from "../../../../core/constants";


@Component({
    selector: 'yo-gef-audit-button',
    templateUrl: './gef-audit-button.component.html',
    styleUrls: ['./gef-audit-button.component.scss'],
    standalone: false
})
export class GefAuditButtonComponent {

  public readonly HAS_GEF = HAS_GEF;

  @Input() gefAuditList: GefAuditDto[];

  constructor(public gestionGefSvc: GestionGefService,
              public auth2Svc: Auth2Service) {
  }

  openGefAuditDialog(event: Event): void {
    event.stopPropagation();
    this.gestionGefSvc.announceOpenGefAuditDialog(this.gefAuditList);
  }

  isValidationRequired(): boolean {
    return this.gefAuditList.some(gefAudit => gefAudit.validationRequired === true);
  }

}
